module.exports = __webpack_public_path__ + "static/media/green-quarter-circle.8ccc9e79.svg";